import shiColors from "../../theme/shiColors";
import {
  type LifecycleStatusValue,
  normalizeLifecycleStatus,
} from "./lifecycleManagementEnums";

const lifecycleStatusColors = {
  NotActioned: shiColors.gray.light,
  Requested: shiColors.orange.DEFAULT,
  Completed: shiColors.green.dark,
  PastDue: shiColors.purple.DEFAULT,
  Canceled: shiColors.red.DEFAULT,
  Ignore: shiColors.gray.light,
  Quoted: shiColors.blue.DEFAULT,
} satisfies Record<LifecycleStatusValue, string>;

export function getLifecycleManagementStatusColor(status: string): string {
  const normalized = normalizeLifecycleStatus(status);

  return normalized ? lifecycleStatusColors[normalized] : shiColors.black;
}
